import * as THREE from 'three'
import Experience from '../Experience.js'

/**
 * Environment
 * Sets up scene lighting and environment map.
 * Adds a DirectionalLight with shadow casting enabled.
 */
export default class Environment {
    constructor() {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.resources = this.experience.resources

        this.setDirectionalLight()
    }

    setDirectionalLight() {
        this.directionalLight = new THREE.DirectionalLight('#ffffff', 4)
        this.directionalLight.castShadow = true
        this.directionalLight.shadow.camera.far = 15
        this.directionalLight.shadow.mapSize.set(1024, 1024)
        this.directionalLight.shadow.normalBias = 0.05
        this.directionalLight.position.set(3.5, 2, -1.25)
        this.scene.add(this.directionalLight)
    }

    destroy() {
        this.scene.remove(this.directionalLight)
        this.directionalLight.dispose()
    }
}
